/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAddressRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/address_service.pb'
import {GetAddressResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/address_service.pb'


export const getAddress = (request: GetAddressRequest, options?: CashRequestOptions) => post<GetAddressRequest, GetAddressResponse>("/2.0/cash/get-address", request, {...options, rejectOnError: true })